<template>
    <div>
        <van-collapse v-model="activate">
            <div style="text-align: center">
                <div v-for="(item,index) in files">
                    <van-collapse-item v-if="item.items.data.length > 0" :title="item.groupName" :name="index">
                        <van-row>
                            <van-col span="8" v-for="(itemImg,index) in item.items.data">
                                <img v-if="itemImg.fileType === 0" width="80" height="80" :src="itemImg.thumbUrl"
                                     @click="showImage(item.items.data,index)"/>
                                <img v-if="itemImg.fileType === 1" :src="itemImg.thumbUrl" width="80" height="80"
                                     style="margin-left: 5px;" @click="showPdf(itemImg)"/>
                                <img v-if="itemImg.fileType === 2" :src="itemImg.thumbUrl" width="80" height="80"
                                     style="margin-left: 5px;" @click="downFile(itemImg)"/>
                                <img v-if="itemImg.fileType === 3" :src="itemImg.thumbUrl" width="80" height="80"
                                     style="margin-left: 5px;" @click="downFile(itemImg)"/>
                                <img v-if="itemImg.fileType === 4" :src="itemImg.thumbUrl" width="80" height="80"
                                     style="margin-left: 5px;" @click="showVideo(itemImg)"/>
                                <img v-if="itemImg.fileType === 5" :src="itemImg.thumbUrl" width="80" height="80"
                                     style="margin-left: 5px;" @click="downFile(itemImg)"/>
                            </van-col>
                        </van-row>
                    </van-collapse-item>
                </div>
            </div>
        </van-collapse>

        <van-popup
                v-model="previewPdf"
                closeable
                close-icon="close"
                position="top"
                :overlay="true"
                :style="{ height: '100%' }"
        >
            <iframe style="width: 100%; height:900px" :src="pdfSrc"></iframe>
        </van-popup>
        <van-popup
                v-model="previewVideo"
                :overlay="true"
                closeable
                close-icon="close"
                position="top"
                :style="{ height: '100%' }"
        >
            <div style="display: flex;justify-content: center;height: 100%;align-items: center">
                <video :src="videoSrc" controls="controls" style="width: 100%;height: 100%">
                    您的浏览器不支持视频预览，请使用Chrome内核的浏览器，谢谢！
                </video>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {ImagePreview} from 'vant'
    import {getForeClousureFileList} from '@/api/loanInfo'
    import {word, excel, ppt, pdf, mp4} from '@/utils/iconBase64'

    const imageReg = /\.(jpg|JPG|jpeg|JPEG|png|PNG|)$/;
    const docReg = /\.(doc|DOC|docx|DOCX|)$/;
    const xlsReg = /\.(xls|XLS|xlsx|XLSX|)$/;
    const pptReg = /\.(ppt|PPT|pptx|PPTX|)$/;
    const videoReg = /\.(mp4|MP4|m4v|M4V|)$/;
    const pdfReg = /\.(pdf|PDF|)$/;
    export default {
        name: 'oss-investigation',
        props: {
            applyId: {
                type: String,
                default: ''
            },
            tabType: {
                type: String,
                default: '-1'
            },
            pictureType: {
                type: String,
                default: '-1'
            }
        },
        data() {
            return {
                previewVideo: false,
                previewPdf: false,
                pdfSrc: '',
                videoSrc: '',
                activate: [],
                files: [],  //当前附件数组
                images: [], // 预览的图片数组
            }
        },
        mounted() {
            this.initData()
        },
        methods: {
            initData() {
                this.files = []
                this.getFileList(this.tabType)
            },
            getFileList(tabType) {
                const self = this
                let params = {
                    applyId: this.applyId,
                    pictureType: this.pictureType,
                    tabType: this.tabType
                }
                getForeClousureFileList(params).then(res => {
                    if (res.success) {
                        // this.images = this.images.concat(res.data)
                        res.data.forEach(item => {
                            let pics = []
                            let documents = []
                            //self.images = []
                            //self.files = []
                            item.items.data.forEach(file => {
                                if (imageReg.test(file.fileSuffix)) {
                                    self.images.push(file.url)
                                    file.fileType = 0
                                    pics.push(file)
                                } else {
                                    // 文件类
                                    if (pdfReg.test(file.fileSuffix)) {
                                        file.fileType = 1
                                        file.thumbUrl = pdf
                                    } else if (docReg.test(file.fileSuffix)) {
                                        file.fileType = 2
                                        file.thumbUrl = word
                                    } else if (xlsReg.test(file.fileSuffix)) {
                                        file.fileType = 3
                                        file.thumbUrl = excel
                                    } else if (videoReg.test(file.fileSuffix)) {
                                        file.fileType = 4
                                        file.thumbUrl = mp4
                                    } else if (pptReg.test(file.fileSuffix)) {
                                        file.fileType = 5
                                        file.thumbUrl = ppt
                                    }
                                    documents.push(file)
                                }
                            })
                            //合并文件（排序图片和文件）
                            item.items.data = pics.concat(documents);
                            //console.log(self.files)
                        })
                        self.files = res.data

                    }
                })
            },
            showImage(data, position) {
                let imgs = []
                data.forEach(item => {
                    if (item.fileType === 0) {
                        imgs.push(item.url)
                    }
                })
                const instance = ImagePreview({
                    images: imgs,
                    lazyLoad: true,
                    startPosition: typeof position === 'number' ? position : 0
                })
            },
            showPdf(data) {
                /*this.pdfSrc = data.url
                this.previewPdf = true*/
                window.open(data.url,'_blank')
            },
            showVideo(data) {
                this.videoSrc = data.url
                this.previewVideo = true
            },
            downFile(file) {
                this.$dialog.confirm({
                    title: '下载文件',
                    message: '是否确认下载『' + file.fileName + '』?'
                }).then(() => {
                    window.open(file.url, '_blank')
                }).catch(() => {
                    // on cancel
                })
            }
        }
    }
</script>

<style scoped>

</style>
